import {
    CategoryTypeEnum,
    UiCategory,
    UiBanner,
    UiBannerItem,
    FlyoutTypeEnum,
} from '../types';

export const ANIMAL_TYPE_TO_BANNER_KEY: Record<string, keyof UiBanner> = {
    DOGS: 'dog',
    CATS: 'cat',
};

export function resolveBannerItem(
    category: UiCategory,
    flyoutType: FlyoutTypeEnum,
    banner: UiBanner | null | undefined,
): UiBannerItem | null {
    if (!banner) {
        return null;
    }

    if (flyoutType === FlyoutTypeEnum.SPECIALS) {
        return banner.specials;
    }

    if (flyoutType !== FlyoutTypeEnum.ANIMAL || !category.animalType) {
        return null;
    }

    const key = ANIMAL_TYPE_TO_BANNER_KEY[category.animalType.toUpperCase()];

    return key ? banner[key] : null;
}

export function isSpecialLink(item: UiCategory) {
    const specialTypes = [
        CategoryTypeEnum.SPECIAL_OFFERS,
        CategoryTypeEnum.NEW_PRODUCTS,
        CategoryTypeEnum.TRIAL_OFFERS,
        CategoryTypeEnum.OUTLET,
    ];
    return item.type ? specialTypes.includes(item.type) : false;
}

export function convertTrackingIdTitle(title: string): string {
    return title
        .split(' ')
        .map((substr) => substr.replace(' ', '-'))
        .join('-');
}

export function getTrackingId({
    type,
    level,
    title,
    index,
    parentTitle,
}: {
    title: string;
    type?: CategoryTypeEnum;
    level: number;
    index?: number;
    parentTitle?: string;
}): string {
    const prefix = 'header-category-flyout-animal';
    if (type === CategoryTypeEnum.SPECIAL_OFFERS) {
        return `${prefix}-special-offer-links-${convertTrackingIdTitle(title)}`;
    }
    if (index !== undefined && parentTitle !== undefined) {
        return `${prefix}-level4-links-${convertTrackingIdTitle(parentTitle)}-${index}-${convertTrackingIdTitle(title)}`;
    }
    return `${prefix}-level${level}-links-${convertTrackingIdTitle(title)}`;
}
